import clsx from 'clsx';
import {AnimatePresence, motion} from 'motion/react';
import {APP_ANIMATIONS} from '@/const';
import styles from './styles.module.scss';

interface IValidationMessage {
    error?: string | null;
    errorStyles?: string[];
}

const ValidationMessage = ({error = null, errorStyles = []}: IValidationMessage) => {
    return (
        <AnimatePresence>
            {!!error && (
                <motion.div {...APP_ANIMATIONS.fadeInOutHeight} className={clsx(styles.error, ...errorStyles)}>
                    {error}
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ValidationMessage;
